import {useState} from "react";
import {Button} from "@/primitives/Button";
import {FA6Icon} from "@/primitives/FA6Icon";
import {ConfirmDialog} from "@/components/confirmDialog";

interface CalendarLinkActionsProps {
	/** Names the panel the links belong to — "Kalender" or "Abwesenheitskalender". */
	calendarName: string;
	busy: boolean;
	onRenew: () => void;
	onDeactivate: () => void;
}


export function CalendarLinkActions({calendarName, busy, onRenew, onDeactivate}: CalendarLinkActionsProps) {
	const [confirming, setConfirming] = useState<"renew" | "deactivate" | null>(null);

	return (
		<div className="text-right">
			<Button variant="outline" onClick={() => setConfirming("renew")} disabled={busy}>
				<FA6Icon icon="arrows-rotate" variant="regular" fixedWidth className="mr-5"/>
				{messages["user.settings.calendar.privateUrl.renew"]}
			</Button>
			<Button
				variant="destructive"
				className="ml-5"
				onClick={() => setConfirming("deactivate")}
				disabled={busy}
			>
				<FA6Icon icon="link-slash" variant="regular" fixedWidth className="mr-5"/>
				{messages["user.settings.calendar.privateUrl.delete"]}
			</Button>

			<ConfirmDialog
				open={confirming === "renew"}
				onOpenChange={(open) => !open && setConfirming(null)}
				title={messages["user.settings.calendar.privateUrl.renew.title"]}
				message={messages.withArguments("user.settings.calendar.privateUrl.renew.confirm", calendarName)}
				cancelLabel={messages["user.settings.calendar.privateUrl.keep"]}
				cancelIcon="link"
				actions={
					<Button
						variant="destructive"
						onClick={() => {
							setConfirming(null);
							onRenew();
						}}
					>
						<FA6Icon icon="arrows-rotate" variant="regular" fixedWidth className="mr-5"/>
						{messages["confirmation.renew"]}
					</Button>
				}
			/>

			<ConfirmDialog
				open={confirming === "deactivate"}
				onOpenChange={(open) => !open && setConfirming(null)}
				title={messages["user.settings.calendar.privateUrl.delete.title"]}
				message={messages.withArguments("user.settings.calendar.privateUrl.delete.confirm", calendarName)}
				cancelLabel={messages["user.settings.calendar.privateUrl.keep"]}
				cancelIcon="link"
				actions={
					<Button
						variant="destructive"
						onClick={() => {
							setConfirming(null);
							onDeactivate();
						}}
					>
						<FA6Icon icon="link-slash" variant="regular" fixedWidth className="mr-5"/>
						{messages["confirmation.disable"]}
					</Button>
				}
			/>
		</div>
	);
}
